// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"686":"7b179d10","775":"a954d5de"}[chunkId] + ".chunk.js";
};